module.exports = __webpack_public_path__ + "static/img/wutu.d797d845.png";